import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { getConfig } from "@jti/fe-common";
const areAllConsentsGiven = (purposes, requiredPurposes) => {
    return requiredPurposes.every((purpose) => purposes.includes(purpose));
};
const selectCart = (state) => state.cart;
const selectCheckout = (state) => state.checkout;
const getGiftQuantityMap = (items) => {
    return items.reduce((acc, item) => {
        if (!item.isGift || !item.parentGiftId)
            return acc;
        const parent = item.parentGiftId;
        const gift = item.sku;
        if (!parent)
            return acc;
        if (!acc[parent])
            acc[parent] = {};
        if (!acc[parent][gift])
            acc[parent][gift] = 0;
        acc[parent][gift] += item.quantity;
        return acc;
    }, {});
};
export const selectFreeGifts = createDraftSafeSelector(selectCart, selectCheckout, (cart, checkout) => {
    var _a;
    const hasGivenConsents = areAllConsentsGiven(checkout.consentPurposes, ((_a = getConfig().freeGiftsPurposes) === null || _a === void 0 ? void 0 : _a.split(",")) || []);
    const isFreeGiftsEnabled = cart.storeConfig.is_free_gifts_enabled && hasGivenConsents;
    const basketGiftsLimit = parseInt(cart.storeConfig.gift_basket_quantity_limitation, 10);
    const giftQuantityMap = getGiftQuantityMap(cart.items);
    const giftsByProduct = cart.items.flatMap(({ id, name, quantity, free_gifts }) => {
        var _a;
        if (!id)
            return [];
        const products = (_a = free_gifts === null || free_gifts === void 0 ? void 0 : free_gifts.products) !== null && _a !== void 0 ? _a : [];
        const eligibleFreeGifts = products.filter(({ is_eligible, product }) => is_eligible && product.stock_status !== "OUT_OF_STOCK") || [];
        if (eligibleFreeGifts.length === 0)
            return [];
        const limitPerItem = (free_gifts === null || free_gifts === void 0 ? void 0 : free_gifts.allowed_qty) || 0;
        const limit = quantity * limitPerItem;
        const freeGifts = eligibleFreeGifts.map(({ product }) => {
            var _a;
            return (Object.assign(Object.assign({}, product), { quantityAddedToCart: ((_a = giftQuantityMap[id]) === null || _a === void 0 ? void 0 : _a[product.sku]) || 0 }));
        });
        return {
            id,
            name,
            quantity,
            limit,
            freeGifts,
        };
    });
    const productsGiftsLimit = giftsByProduct.reduce((acc, { limit }) => acc + limit, 0);
    const limit = Math.min(basketGiftsLimit, productsGiftsLimit);
    return {
        isFreeGiftsEnabled,
        limit,
        giftsByProduct,
    };
});
//# sourceMappingURL=selectFreeGifts.js.map